export default "__VITE_ASSET__DoAe90d$__"